// @ts-ignore
import {
  Dialog,
  Modal,
} from '@oliasoft-open-source/react-ui-library';
import { useState } from 'react';
import { ArchiveSelector } from './archive-selector';
import DesignSelector from './design-selector';
import { UnpackSteps } from './constants';

type UnpackModalProps = {
  visible: boolean
  onClose: () => void,
  onPreUnpackObject: Function,
  onUnpackObject: Function,
  name: string
};

export const UnpackModal = ({
  visible,
  onClose,
  onPreUnpackObject,
  onUnpackObject,
  name,
}: UnpackModalProps) => {
  const [selectedStep, setSelectedStep] = useState<UnpackSteps>(UnpackSteps.SelectArchive);

  const [selectedArchiveId, setSelectedArchive] = useState<string | null>(null);
  const [selectedCountryName, setSelectedCountry] = useState<string | null>(null);

  const handleConfirmNextStep = (stepName: UnpackSteps) => setSelectedStep(stepName);
  
  const stepsMap = {
    [UnpackSteps.SelectArchive]: <ArchiveSelector 
      onClose={onClose} 
      selectedArchiveId={selectedArchiveId!}
      setSelectedArchive={setSelectedArchive}
      setSelectedCountry={setSelectedCountry}
      selectedCountryName={selectedCountryName!}
      handleConfirmNextStep={() => handleConfirmNextStep(UnpackSteps.SelectDesing)}
      onPreUnpackObject={onPreUnpackObject}
    />,
    [UnpackSteps.SelectDesing]: <DesignSelector 
      onClose={onClose}
      handleConfirmNextStep={(selectedDesingIds: string[]) => {
        onUnpackObject(selectedCountryName, selectedDesingIds, selectedArchiveId);
      }}
    />,
  };

  const content = stepsMap[selectedStep];
  return (
    <Modal visible={visible} centered>
      <Dialog
        dialog={{
          scroll: false,
          heading: `Unpack EDM: ${name}`,
          content,
          onClose,
        }}
      />
    </Modal>
  );
};
